import Requester from '../../helpers/requester';
import { HTTP_METHODS } from '../../helpers/constants';
import { API_PATHS } from '../../helpers/endpoints';

export default {
  getGeoRadarZones: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.GEO_RADAR_ZONES_SEARCH}?${queryString}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getAllGeoRadarZones: async () => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.GEO_RADAR_ZONES}/all`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getGeoRadarZoneTypes: async () => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.GEO_RADAR_ZONES}/types`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  addGeoRadarZone: async (data) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.GEO_RADAR_ZONES}`,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getGeoRadarZoneHistory: async (zoneId) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.GEO_RADAR_ZONES}/history/${zoneId}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  cityLocalBoundaries: async (data) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.GEOLOCATION}/city-local-boundaries`,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  districtLocalBoundaries: async (data) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.GEOLOCATION}/district-local-boundaries`,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  neighborhoodLocalBoundaries: async (data) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.GEOLOCATION}/neighborhood-local-boundaries`,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  geoRadarApprove: async (geoRadarZoneData) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.GEO_RADAR_ZONES_APPROVE}/${geoRadarZoneData.id}`,
        method: HTTP_METHODS.PUT,
        data: { isApproved: geoRadarZoneData.isApproved },
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  editGeoRadarZone: async (geoRadarZoneData) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.GEO_RADAR_ZONES}/${geoRadarZoneData.id}`,
        method: HTTP_METHODS.PUT,
        data: geoRadarZoneData,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getIsochroneZone: async (latitude, longitude, doubleTime) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.ISOCHRONE_ZONE}?lat=${latitude}&long=${longitude}&maxRouteDuration=${doubleTime}`,
        method: HTTP_METHODS.GET,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  editVersionGeoRadarZone: async (geoRadarZoneData) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.GEO_RADAR_ZONES_VERSION}/${geoRadarZoneData.id}`,
        method: HTTP_METHODS.PUT,
        data: geoRadarZoneData,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getRivalsByLocation: async (data) => {
    try {
      const response = await Requester.submit({
        url: API_PATHS.GEO_RADAR_RIVALS_BY_LOCATION,
        method: HTTP_METHODS.POST,
        data,
      });
      return response?.data;
    } catch (error) {
      throw error;
    }
  },

  geoRadarZoneMove: async (data) => {
    try {
      const response = await Requester.submit({
        url: API_PATHS.GEO_RADAR_ZONE_MOVE,
        method: HTTP_METHODS.PUT,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  geoRadarZoneRevert: async (zoneId, data) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.GEO_RADAR_ZONE_REVERT}/${zoneId}`,
        method: HTTP_METHODS.PUT,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getCityBoundariesByRegion: async (storeId) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.GET,
        url: `${API_PATHS.GEOLOCATION}/city-local-boundary-by-store-ids?storeIds=${storeId}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getDistrictBoundariesByRegion: async (storeId) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.GET,
        url: `${API_PATHS.GEOLOCATION}/district-local-boundary-by-store-ids?storeIds=${storeId}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getNeighborhoodBoundariesByRegion: async (regionIds) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.GEOLOCATION}/neighborhood-local-boundary-by-region-ids`,
        data: regionIds,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getAllZonesNearbySelectedZone: async (zoneId) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.GET,
        url: `${API_PATHS.GEO_RADAR_ZONES}/all-nearby/${zoneId}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getOrderCountOfZone: async (data, zoneId) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.GEO_RADAR_ZONES}/order-count/${zoneId}`,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },


  zoneMove: async (data) => {
    try {
      const response = await Requester.submit({
        url: API_PATHS.ZONE_MOVE,
        method: HTTP_METHODS.PUT,
        data
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getOrderCountInfoForZoneMove: async (zoneId) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.GET, url: `${API_PATHS.ZONES_V2}/${zoneId}/order-count`
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateAllZoneDeliveryFees: async (data) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.ZONE_DELIVERY_FEES}`,
        method: HTTP_METHODS.PUT,
        data
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateAllZoneMinimumCartAmount: async (minCartAmount) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.ZONE_MINIMUM_CART_AMOUNT}?minCartAmount=${minCartAmount}`,
        method: HTTP_METHODS.PUT,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },  

};
